$shm_ba_search_settings $mol_view
	search_mode? \fts
	search_case_sensitive? true
	sub /
		<= Title $mol_view
			sub /
				\Поиск по постам
		<= Mode_select $mol_select
			value? <=> search_mode? \fts
			dictionary <= mode_options *
				fts \FTS
				substring \Подстрока
		<= Case_sensitive $mol_check_box
			title \Учитывать регистр
			checked? <=> search_case_sensitive? true
		<= Description $mol_view
			sub /
				<= description \
